import React, { useCallback } from 'react'

const contrastColors = {
  yellow: '#000',
  gold: '#000',
  white: '#000',
  black: '#fff',
  red: '#fff',
  blue: '#fff',
  green: '#fff',
  orange: '#000',
  purple: '#fff',
};

const _contrastColors = {
  yellow: '#000',
  gold: '#000',
  white: '#000',
  black: '#fff',
  red: '#fff',
  blue: '#fff',
  green: '#fff',
  orange: '#000',
  purple: '#fff',
};

export const useColors = () => {

  const getContrastColor = useCallback((backgroundColor) => {

    if (contrastColors[backgroundColor]) {
      return contrastColors[backgroundColor]
    }
    const el = document.createElement('div');
    el.style.color = backgroundColor;
    document.body.appendChild(el);
    const rgb = getComputedStyle(el).color;
    document.body.removeChild(el);
    const [r, g, b] = rgb.match(/\d+/g).map(Number);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 150 ? '#000000' : '#FFFFFF';
  }, []);

  const getSplitColors = useCallback(({ backgroundColor, colorProps }) => {
    const color_s = backgroundColor ? backgroundColor.split('/') : []
    if (color_s.length > 1) {
      colorProps.backgroundColor = color_s[0].toLowerCase()
      colorProps.borderColor = color_s[1].toLowerCase()
    } else {
      colorProps.backgroundColor = backgroundColor ? backgroundColor.toLowerCase() : null
    }
  }, []);

  const getSplitColorStyles = useCallback(({ backgroundColor }) => {
    const colorProps = { backgroundColor: null, borderColor: null, color: null };
    getSplitColors({ backgroundColor: backgroundColor, colorProps })
    colorProps.color = getContrastColor(colorProps.backgroundColor)
    return {
      textDecoration: `underline 1px ${colorProps.borderColor}`,
      backgroundColor: colorProps.backgroundColor,
      color: colorProps.color,
      textUnderlineOffset: '2px'
    }
  }, []);

  return { getContrastColor, getSplitColors, getSplitColorStyles }
}
